import * as React from 'react';
import {createElement} from "react";
import {useTranslate} from 'react-admin';
import EuroIcon from '@mui/icons-material/Euro';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {Box, Card, CardHeader, Grid, Tooltip, Typography} from "@mui/material";
import {format} from "date-fns";
import {Logo} from "../layout/Logo";
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import {QuickViewReport} from "../utils/types";

interface MarketplaceDailyReturns {
    marketplace: string;
    total: number;
}

const ReturnsDashboard = (props: {report: QuickViewReport}) => {
    const {report} = props;
    const translate = useTranslate();

    return (
        <Grid container spacing={2} padding={1}>
            <Box mt={2} ml={-3} display="flex">
                <Logo/>
            </Box>

            <Grid item xs={12}>
                <div style={{display: 'flex'}}>
                    {report ?
                        (report.data as MarketplaceDailyReturns[]).map((item: MarketplaceDailyReturns, index) => {
                            return (
                                <Card
                                    sx={{
                                        cursor: 'help',
                                        minHeight: 52,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: '1',
                                        '& a': {
                                            textDecoration: 'none',
                                            color: 'inherit',
                                        },
                                        marginLeft: index === 0 ? 0 : 2,
                                    }}
                                >
                                    <CardHeader
                                        subheader={<Typography variant="caption" color="textPrimary">{item.marketplace}</Typography>}
                                        sx={{padding: '2px', textAlign: 'center'}}
                                    />
                                    <Tooltip
                                        title={translate('resources.reports.quickViewReports.lastUpdate', {
                                            smart_count: 1,
                                            date: format(new Date(report.updatedAt), 'dd.MM.yyyy HH:mm')
                                        })}
                                    >
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                overflow: 'hidden',
                                                padding: '16px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                '& .icon': {
                                                    color: 'secondary.main',
                                                },
                                                '&:before': {
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: 0,
                                                    display: 'block',
                                                    content: `''`,
                                                    height: '200%',
                                                    aspectRatio: '1',
                                                    transform: 'translate(-30%, -60%)',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'secondary.main',
                                                    opacity: 0.15,
                                                },
                                            }}
                                        >
                                            <Box width="3em" className="icon">
                                                {createElement(AssignmentReturnIcon, {fontSize: 'large'})}
                                            </Box>
                                            <Box textAlign="right">
                                                <Typography color="textSecondary">{translate('resources.reports.quickViewReports.returns.total')}</Typography>
                                                <Typography variant="h5" component="h2">
                                                    {item.total || ' '}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Tooltip>
                                </Card>
                            );
                        }) : null
                    }
                </div>
            </Grid>
        </Grid>
    );
};

export default ReturnsDashboard;
